import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/web.dom-collections.for-each.js";
var fileDownload = require("js-file-download");
import { request } from "@/js/http/http_request";
import { hasRole } from "@/js/http/auth";
import { formRules } from "@/js/form_rules.js";
import { getErrorData, filterVAutocomplete } from "@/js/forms.js";
import { cloneDbEnvironment } from "@/js/lists.ts";
import Error from "@/views/error/error.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import UploaderV2 from "@/components/default/UploaderV2.vue";
import LaunchMaintenanceDrawer from "@/components/maintenance/LaunchMaintenanceDrawer.vue";
import MaintenanceCountdown from "@/components/maintenance/MaintenanceCountDown.vue";
import ScheduledMaintenanceList from "@/components/maintenance/ScheduledMaintenanceList.vue";
export default {
  name: "AdminDeveloperTools",
  components: {
    Error: Error,
    Confirm: Confirm,
    UploaderV2: UploaderV2,
    LaunchMaintenanceDrawer: LaunchMaintenanceDrawer,
    MaintenanceCountdown: MaintenanceCountdown,
    ScheduledMaintenanceList: ScheduledMaintenanceList
  },
  props: ["loggedUserData"],
  data: function data() {
    return {
      tab: null,
      exports: {
        isExporting: false,
        selectedChoice: null,
        choices: {
          DATABASE_INCONSISTENCIES: {
            id: 1,
            name: "Database inconsistencies",
            apiUrl: "database-inconsistencies",
            fileName: "DATABASE_INCONSISTENCIES.xlsx"
          },
          ACCOUNTANCY_RECONCILIATION_DATA: {
            id: 2,
            name: "Accountancy reconciliation data",
            apiUrl: "accountancy-reconciliation-data",
            fileName: "ACCOUNTANCY_RECONCILIATION_DATA.xlsx"
          },
          ORDERS_SHIPPED: {
            id: 3,
            name: "Orders shipped data",
            apiUrl: "orders-shipped",
            fileName: "ORDERS_SHIPPED.xlsx"
          },
          PO_RECEIVED: {
            id: 4,
            name: "PO received",
            apiUrl: "po-received",
            fileName: "PO_RECEIVED.xlsx"
          }
        }
      },
      scripts: {
        isWorking: false,
        isCompleted: false,
        dateStart: null,
        dateCompleted: null,
        selectedChoice: null,
        formCloneDb: {
          fromDb: null,
          toDb: null
        },
        choices: {
          CLONE_DB: {
            id: 1,
            name: "Clone DB",
            apiUrl: "clone-db"
          },
          PUNCTUAL_SCRIPT: {
            id: 2,
            name: "Punctual dev script",
            apiUrl: "punctual-dev"
          },
          RECALCULATE_VAT_AMOUNT_SPECIFIC_COUNTRIES: {
            id: 3,
            name: "Recalculate vat amount specific countries",
            apiUrl: "recalculate-vat-specific-strategy"
          },
          REFRESH_WINES_IMAGES: {
            id: 4,
            name: "Refresh wines images",
            apiUrl: "refresh-wines-images"
          },
          RECALCULATE_COMMISSIONS: {
            id: 5,
            name: "Recalculate commissions",
            apiUrl: "recalculate-commissions"
          },
          REFRESH_CREDITS: {
            id: 6,
            name: "Regenerate credit notes",
            apiUrl: "refresh-credits"
          },
          RANDOMIZE_SENSITIVE_DATA: {
            id: 7,
            name: "Randomize sensitive data",
            apiUrl: "randomize-sensitive-data",
            confirm: true
          },
          RECALCULATE_ACCOUNTANCY_AMOUNT: {
            id: 8,
            name: "Recalculate accountancy amounts",
            apiUrl: "recalculate-accountancy-amounts"
          },
          MIGRATE_REGION_IMAGES: {
            id: 9,
            name: "Migrate regions & sub-regions images",
            apiUrl: "migrate-regions-images"
          },
          UPDATE_COMMISSIONS_TRUMP_2025_05: {
            id: 10,
            name: "Update commissions Trump 2025-05",
            apiUrl: "update-commissions-trump-2025-05"
          },
          RESTART_CACHE_CONTAINER: {
            id: 11,
            name: "Restart cache container",
            apiUrl: "restart-cache",
            confirm: true
          },
          DELETE_ALL_CACHE_KEYS: {
            id: 12,
            name: "Clean all cache keys",
            apiUrl: "clean-cache",
            confirm: true
          }
        },
        errorHtmlMessage: null
      },
      crons: {
        isWorking: false,
        isCompleted: false,
        dateStart: null,
        dateCompleted: null,
        selectedChoice: null,
        choices: {
          CELLAR_STORAGE_REMINDER: {
            id: 1,
            name: "Send reminder for cellar storage",
            apiUrl: "cellar-storage-reminder"
          },
          CREATE_WINE_SEARCHER_INVENTORIES: {
            id: 2,
            name: "Wine-searcher create inventory files",
            apiUrl: "wine-searcher-inventories"
          },
          SOON_PAYMENTS_FIRST_WARNING: {
            id: 3,
            name: "Send reminders to customers for payments due soon",
            apiUrl: "payments-soon-reminder"
          },
          LATE_PAYMENTS_FIRST_WARNING: {
            id: 4,
            name: "Send reminders to customers for overdue, first warning",
            apiUrl: "payments-late-reminder-first-warning"
          },
          LATE_PAYMENTS_REPORT: {
            id: 5,
            name: "Send report to admins for late payments",
            apiUrl: "late-payments-report"
          },
          LOW_STOCK_ALERT: {
            id: 6,
            name: "Send report to admins for low stock alert",
            apiUrl: "stocks-low-stock-alerts"
          },
          ITEM_CHANGES: {
            id: 7,
            name: "Send report for item changes in orders",
            apiUrl: "item-changes-report"
          },
          APPLY_SCHEDULED_PRICE_MODIFICATIONS: {
            id: 8,
            name: "Apply scheduled price modifications",
            apiUrl: "scheduled-price-modifications"
          },
          CATEGORY_USER_REMINDER: {
            id: 9,
            name: "Send reminder for category user",
            apiUrl: "category-user-reminder"
          },
          INITIALIZE_PAYMENTS: {
            id: 10,
            name: "Initialize payments",
            apiUrl: "initialize-payments"
          },
          EMPTY_FORSAKEN_ORDERS: {
            id: 11,
            name: "Empty forsaken orders",
            apiUrl: "empty-forsaken-orders"
          },
          CLEAN_OBSOLETE_TRUMP_COMMISSIONS: {
            id: 12,
            name: "Clean obsolete trump commissions",
            apiUrl: "clean-obsolete-trump-commissions"
          },
          PURGE_CUSTOMER_STRIPE_PAYMENTS_METHODS: {
            id: 13,
            name: "Purge customer Stripe payment methods",
            apiUrl: "purge-customer-stripe-payment-methods"
          },
          SEND_FRANCE_STOCKS_STATE: {
            id: 14,
            name: "Send France stocks state",
            apiUrl: "send-france-stocks-state"
          },
          SEND_PO_REPORTS: {
            id: 15,
            name: "Send purchase orders late report",
            apiUrl: "purchase-orders-late-report"
          }
        }
      },
      fileImport: {
        isWorking: false,
        isCompleted: false,
        dateStart: null,
        dateCompleted: null,
        errorHtmlMessage: null,
        uploaderFiles: [],
        urlApi: "".concat(process.env.VUE_APP_API_URL, "/v1/scripts/punctual-import")
      },
      formRules: formRules,
      cloneDbEnvironment: cloneDbEnvironment
    };
  },
  computed: {
    hasAccessToPage: function hasAccessToPage() {
      return hasRole(process.env.VUE_APP_ROLES_USE_DEVELOPER_TOOLS);
    },
    maintenanceMode: {
      get: function get() {
        return this.$maintenanceMode.isActive;
      }
    }
  },
  created: function created() {},
  methods: {
    exportFile: function exportFile() {
      var _this = this;
      _this.exports.isExporting = true;
      var url = "/v1/exports/";
      var fileName = null;
      Object.keys(_this.exports.choices).forEach(function (key) {
        if (_this.exports.choices[key].id == _this.exports.selectedChoice) {
          url += _this.exports.choices[key].apiUrl;
          fileName = _this.exports.choices[key].fileName;
        }
      });
      request(url, "get", null, true, "api", "blob").then(function (response) {
        fileDownload(response.data, fileName, "application/xlsx");
        _this.exports.isExporting = false;
      }).catch(function (e) {
        _this.exports.isExporting = false;
        var errorData = getErrorData(e, _this.managedExceptions);
        _this.$toasted.show(errorData.message, {
          type: errorData.type
        });
      });
    },
    launchScript: function launchScript() {
      var _this2 = this;
      var selectedScript = Object.values(this.scripts.choices).find(function (choice) {
        return choice.id === _this2.scripts.selectedChoice;
      });
      if (selectedScript) {
        this.confirmScript(selectedScript, function () {
          _this2.executeScript(selectedScript);
        });
      }
    },
    confirmScript: function confirmScript(script, callback) {
      var hostname = window.location.hostname;
      if (script.confirm) {
        this.$refs.confirm.open("Execute script", "Are you sure you want to execute the script \"".concat(script.name, "\" on the environment at ").concat(hostname, "?"), {
          color: "red"
        }).then(function (confirm) {
          if (confirm) {
            callback();
          }
        });
      } else {
        callback();
      }
    },
    executeScript: function executeScript() {
      this.resetScript();
      var _this = this;
      _this.scripts.isWorking = true;
      _this.scripts.dateStart = new Date();
      var url = "/v1/scripts/";
      var data = null;
      Object.keys(_this.scripts.choices).forEach(function (key) {
        if (_this.scripts.choices[key].id == _this.scripts.selectedChoice) {
          url += _this.scripts.choices[key].apiUrl;
          data = null;
          if (key === "CLONE_DB") {
            data = {
              backupEnv: _this.scripts.formCloneDb.fromDb,
              restoreEnv: _this.scripts.formCloneDb.toDb
            };
          }
        }
      });
      request(url, "put", data, true, "api", "blob").then(function (_) {
        _this.scripts.isWorking = false;
        _this.scripts.isCompleted = true;
        _this.scripts.dateCompleted = new Date();
      }).catch(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
          var _error$response$data$, _error$response;
          var error, errorData;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this.scripts.isWorking = false;
                _context.next = 3;
                return Object.blobExToJsonEx(e);
              case 3:
                error = _context.sent;
                _this.scripts.errorHtmlMessage = (_error$response$data$ = (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 || (_error$response = _error$response.value) === null || _error$response === void 0 ? void 0 : _error$response.errorMessage) !== null && _error$response$data$ !== void 0 ? _error$response$data$ : null;
                errorData = getErrorData(error, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    resetScript: function resetScript() {
      this.scripts.isCompleted = null;
      this.scripts.dateStart = null;
      this.scripts.dateCompleted = null;
      this.scripts.isWorking = false;
      this.scripts.errorHtmlMessage = null;
    },
    fileImportSyncFiles: function fileImportSyncFiles(uploaderFiles) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.fileImport.uploaderFiles = _toConsumableArray(uploaderFiles);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fileImportSubmit: function fileImportSubmit() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.fileImportReset();
              _this4.fileImport.isWorking = true;
              _this4.fileImport.isCompleted = false;
              _this4.fileImport.dateStart = new Date();
              _this4.$refs.uploaderFileImport.uploadAll();
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fileImportAcknowledgeUpload: function fileImportAcknowledgeUpload(response) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.fileImport.isWorking = false;
              _this5.fileImport.isCompleted = true;
              _this5.fileImport.dateCompleted = new Date();
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fileImportUploadFailed: function fileImportUploadFailed() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.fileImport.isWorking = false;
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    fileImportReset: function fileImportReset() {
      this.fileImport.isCompleted = null;
      this.fileImport.dateStart = null;
      this.fileImport.dateCompleted = null;
      this.fileImport.isWorking = false;
      this.fileImport.errorHtmlMessage = null;
    },
    launchCron: function launchCron() {
      var _this7 = this;
      var selectedCron = Object.values(this.crons.choices).find(function (choice) {
        return choice.id === _this7.crons.selectedChoice;
      });
      if (selectedCron) {
        this.confirmCron(selectedCron, function () {
          _this7.executeCron(selectedCron);
        });
      }
    },
    confirmCron: function confirmCron(cron, callback) {
      var hostname = window.location.hostname;
      if (cron.confirm) {
        this.$refs.confirm.open("Execute cron", "Are you sure you want to execute the cron \"".concat(cron.name, "\" on the environment at ").concat(hostname, "?"), {
          color: "red"
        }).then(function (confirm) {
          if (confirm) {
            callback();
          }
        });
      } else {
        callback();
      }
    },
    executeCron: function executeCron() {
      this.resetCron();
      var _this = this;
      _this.crons.isWorking = true;
      _this.crons.dateStart = new Date();
      var url = "/v1/scripts/";
      Object.keys(_this.crons.choices).forEach(function (key) {
        if (_this.crons.choices[key].id == _this.crons.selectedChoice) {
          url += _this.crons.choices[key].apiUrl;
        }
      });
      request(url, "put", null, true, "api", "blob").then(function (_) {
        _this.crons.isWorking = false;
        _this.crons.isCompleted = true;
        _this.crons.dateCompleted = new Date();
      }).catch(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
          var _error$response$data$2, _error$response2;
          var error, errorData;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _this.crons.isWorking = false;
                _context6.next = 3;
                return Object.blobExToJsonEx(e);
              case 3:
                error = _context6.sent;
                _this.crons.errorHtmlMessage = (_error$response$data$2 = (_error$response2 = error.response) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.data) === null || _error$response2 === void 0 || (_error$response2 = _error$response2.value) === null || _error$response2 === void 0 ? void 0 : _error$response2.errorMessage) !== null && _error$response$data$2 !== void 0 ? _error$response$data$2 : null;
                errorData = getErrorData(error, _this.managedExceptions);
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              case 7:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    resetCron: function resetCron() {
      this.crons.isCompleted = null;
      this.crons.dateStart = null;
      this.crons.dateCompleted = null;
      this.crons.isWorking = false;
      this.crons.errorHtmlMessage = null;
    },
    openLaunchMaintenanceDrawer: function openLaunchMaintenanceDrawer() {
      this.$refs.launchMaintenanceDrawer.openDrawer(null);
    },
    deactivateMaintenanceMode: function deactivateMaintenanceMode() {
      this.$maintenanceMode.deactivate();
    },
    filterVAutocomplete: filterVAutocomplete
  }
};